module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_5010.3a3453fa.png";